<template>
  <draggable
    :class="[
      'bg-white dark:border-dark-divider-border border-white dark:bg-dark-box-background py-4 px-2',
      `grid ${fullScreen ? 'grid-cols-2' : 'grid-cols-1'} gap-x-8 overflow-visible mt-1 border-0 ${
        $store.state.ui.darkMode ? 'dark-scrollbar' : ''
      } dark:border-dark-divider-border rounded-lg text-base ring-0 overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration`
    ]"
    :component-data="{ type: 'transition-group' }"
    v-bind="{
      disabled: true,
      animation: 200,
      modelValue: tasks_clone,
      group: 'group',
      ghostClass: 'ghost',
      chosenClass: 'chosen'
    }"
    item-key="id">
    <template #item="{ element: item }">
      <div :key="item?.id" class="w-full bg-white">
        <div class="w-full">
          <div
            v-if="expanded_tasks.includes(item.id)"
            class="relative p-4 mb-4 border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
            <div class="flex items-center">
              <div class="ml-2">
                {{ item.name }}
              </div>
              <div class="absolute flex -right-3 -top-3 gap-x-2">
                <div
                  class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                  @click="handleExpandTask(item)">
                  <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
                  <span
                    class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                    {{ $t("Minimize") }}</span>
                </div>
                <div
                  class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
                  @click="handleViewTask(item)">
                  <Maximize2
                    class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration"
                    color="#2DA7D7" />
                  <span
                    class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                    {{ $t("View Task") }}</span>
                </div>
              </div>
            </div>
            <div class="flex w-full mt-5">
              <div class="w-1/3">
                <div class="flex flex-row items-center gap-2">
                  <div class="text-common-grey">
                    {{ $t("Priority") }}:
                  </div>

                  <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
                    <div v-if="item.priority" class="flex items-center capitalize gap-x-2">
                      <div>
                        {{ item.priority }}
                      </div>
                      <div>
                        <div v-if="item.priority == 'normal'">
                          <div :class="[`border-b-2 w-3  border-status-warning-yellow`]" />
                          <div :class="[`border-b-2 w-3 mt-1 border-status-warning-yellow`]" />
                        </div>
                        <div v-else-if="item.priority == 'high'">
                          <ChevronRight class="w-5 h-5 -rotate-90 text-status-error-red" />
                        </div>
                        <div v-else-if="item.priority == 'highest'">
                          <ChevronsRight class="w-5 h-5 -rotate-90 text-status-error-red" />
                        </div>
                        <div v-else-if="item.priority == 'low'">
                          <ChevronRight class="w-5 h-5 rotate-90 text-status-success-green" />
                        </div>
                        <div v-else-if="item.priority == 'lowest'">
                          <ChevronsRight class="w-5 h-5 rotate-90 text-status-success-green" />
                        </div>
                      </div>
                    </div>

                    <span v-else> - </span>
                  </div>
                </div>
              </div>

              <div class="w-1/3">
                <div class="flex flex-row items-center gap-2">
                  <div class="text-common-grey whitespace-nowrap">
                    {{ $t("Due Date") }}:
                  </div>

                  <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
                    <span v-if="item.due_date">
                      {{ $moment(item.due_date).format("DD MMM YYYY") }}
                    </span>

                    <span v-else> - </span>
                  </div>
                </div>
              </div>

              <div :class="[`${item?.assigned_to.length > 4 ? 'w-[16%]' : ''}`]" class="ml-auto -mt-8">
                <div
                  :class="[`${item?.assigned_to.length > 4 ? '' : '-ml-10'}`]"
                  class="mb-2 text-common-grey whitespace-nowrap text-start">
                  {{ $t("Team Members") }}
                </div>
                <div class="flex items-center -ml-5 -space-x-4 overflow-hidden">
                  <span v-for="user in item?.assigned_to.slice(0, 4)" :key="user" class="inline-block has-tooltip">
                    <img
                      v-if="$utils.getUserById(user, 'avatar')"
                      class="inline-block rounded-full h-9 w-9 object-cover"
                      :src="$utils.getUserById(user, 'avatar')"
                      alt="">
                    <Avatar
                      v-else
                      :first-name="$utils.getUserById(user, 'first_name')"
                      :last-name="$utils.getUserById(user, 'last_name')" />
                    <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                      <div class="">
                        <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                          {{ $utils.getUserById(user, "full_name") }}
                        </p>
                      </div>
                    </span>
                  </span>
                  <span
                    v-if="item?.assigned_to.length > 4"
                    class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                    + {{ item?.assigned_to.length - 4 }} {{ $t("more") }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="relative items-center flex p-4 mb-4 align-middle border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
            <div
              :class="[
                'w-4 h-4 rounded-full mt-1 mr-4 relative',
                {
                  'bg-dark-brand-blue': ['in-progress', 'pending'].includes(item.status),
                  'bg-status-warning-yellow': item.status == 'overdue',
                  'bg-status-success-green': item.status == 'completed',
                  'bg-status-error-red': ['cancelled', 'missed'].includes(item.status)
                }
              ]" />
            <Tally2 class="w-4 h-4 mr-2 cursor-move rotate-90" />

            <div>{{ item.name }}</div>

            <div class="absolute flex -right-3 -top-3 gap-x-2">
              <div
                class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
                @click="handleViewTask(item)">
                <Maximize2
                  class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration"
                  color="#2DA7D7" />
                <span
                  class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                  {{ $t("View Task") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </draggable>
</template>

<script>
import { Maximize2, ChevronsRight, ChevronRight, Tally2 } from "lucide-vue-next"
import draggable from "vuedraggable"
import Avatar from "@/components/shared/Avatar.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { draggable, Avatar, ChevronRight, ChevronsRight, Maximize2, Tally2 },
  props: {
    tasks: {
      type: Array,
      default: () => [],
      required: true
    },
    currentCompany: {
      type: Object,
      default: () => {},
      required: false
    },
    fullScreen: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      ALL_EMITTERS,
      expanded_tasks: [],
      tasks_clone: []
    }
  },
  watch: {
    tasks() {
      this.tasks_clone = this.tasks.map((task) => {
        return {
          ...task,
          record: this.currentCompany,
          assigned_to: [this.$store.state.auth.user.id],
          tags: [],
          status: task?.status || "pending"
        }
      })
    }
  },
  created() {
    this.tasks_clone = this.tasks.map((task) => {
      return {
        ...task,
        record: this.currentCompany,
        assigned_to: [this.$store.state.auth.user.id],
        tags: [],
        status: task?.status || "pending"
      }
    })
  },
  methods: {
    handleExpandTask(task) {
      let index = this.expanded_tasks.findIndex((t) => t == task.name)
      if (index !== -1) {
        this.expanded_tasks.splice(index, 1)
      } else {
        this.expanded_tasks.push(task.name)
      }
    },
    handleViewTask(task) {
      this.$emitter.emit(ALL_EMITTERS.CREATE_TASK, this.$utils.clone(task))
    }
  }
}
</script>
